const ConfiguracaoCallCenter = () => import( '../_views/ConfiguracaoCallCenter')
import { permissionsConfigCallCenter } from '../../../utils/permissionsCallCenter'

export default [
    {
      path: 'configuracao-call-center',
      meta: { requiresAuth: true, permissions: [...permissionsConfigCallCenter] },
      component: ConfiguracaoCallCenter,
      name: 'ConfiguracaoCallCenter',
    },
]